/*
 *  Class Accordion
 */
export
default class Accordion {
    constructor() {
        this.accordions = document.querySelectorAll('.accordion:not(.preview)');
    }

    showMenu(e) {
        e.preventDefault();
        this.body.classList.add('mm-visible');
    }

    toggleItem(e) {
        e.preventDefault();
        const current = e.target.closest('.accordion__item');
        const items = e.target.closest('.accordion').querySelectorAll('.accordion__item');
        items.forEach(function (item) {
            var content = item.querySelector('.accordion__content');
            if (item === current && !item.classList.contains('active')) {
                item.classList.add('active');
                content.style.maxHeight = content.scrollHeight + 'px';
            } else {
                item.classList.remove('active');
                content.style.maxHeight = null;
            }
        }.bind(this));
    }

    init() {
        this.accordions.forEach(function (accordion) {
            accordion.querySelectorAll('.accordion__title').forEach(function (
                itemTitle) {
                itemTitle.addEventListener('click', this.toggleItem.bind(this));
            }.bind(this));
        }.bind(this));
    }
}
